module.exports = __webpack_public_path__ + "img/HMQ.0fabddee.svg";